import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type UploadState = {
  progress: number;
  isUploading: boolean;
  status: 'idle' | 'uploading' | 'success' | 'error';
  successfulCount: number;
  failedCount: number;
};

const initialState: UploadState = {
  progress: 0,
  isUploading: false,
  status: 'idle',
  successfulCount: 0,
  failedCount: 0,
};

export const uploadSlice = createSlice({
  name: 'upload',
  initialState,
  reducers: {
    setProgress: (state, action: PayloadAction<number>) => {
      state.progress = action.payload;
    },
    setStatus: (state, action: PayloadAction<UploadState['status']>) => {
      state.status = action.payload;
      state.isUploading = action.payload === 'uploading';
    },
    setSummary: (
      state,
      action: PayloadAction<{ successful: number; failed: number }>
    ) => {
      state.successfulCount = action.payload.successful;
      state.failedCount = action.payload.failed;
    },
    resetUpload: () => initialState,
  },
});

export const { setProgress, setStatus, setSummary, resetUpload } =
  uploadSlice.actions;

export default uploadSlice.reducer;
